export const containerStyle = {
    bgcolor: "background.paper",
    width: { xs: "300px", sm: "300px", md: "500px" },
    boxShadow: 24,
    outline: "none",
    padding: 3,
};

export const modalStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};

export const titleStyle = {
    fontWeight: 500,
    fontSize: "14px",
    color: "#3A3541CC",
};
